import { httpUtil } from "./httpUtil";
import { ErrorCodes, createCommonResult, createResult } from "./resultUtil";

export const payment = {
    getPaymentForm,
    getIntegrations,
    getFormAddCard,
    createTopups,
    createPayment,
}

async function getPaymentForm({
    integration_id,
    device_type,
    redirect_url,
    currency_code,
    amount,
    estimation_id,
    payment_method_id,
    type,
    header_accept, 
    header_accept_language, 
    browser_color_depth, 
    browser_screen_height, 
    browser_screen_width, 
    browser_java_enabled, 
    time_zone_offset, 
    user_agent
}) {
    try {
        let response = await httpUtil.get({
            resourcePath: '/v2/hosted_pages/payments',
            withAccessToken: true,
            queryParams: {
                integration_id,
                device_type,
                redirect_url,
                currency_code,
                amount,
                estimation_id,
                payment_method_id,
                type,
                header_accept, 
                header_accept_language, 
                browser_color_depth, 
                browser_screen_height, 
                browser_screen_width, 
                browser_java_enabled, 
                time_zone_offset, 
                user_agent
            },
            returnText: true
        });
        return createCommonResult(response);
    } catch (e) {
        console.log('Exception getPaymentForm: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function getIntegrations({
    connector,
    finance,
    payment_method,
    rewards,
    transactions,
    type,
}, id) {
    try {
        let response = await httpUtil.get({
            resourcePath: '/v2/applications/' + id + '/integrations',
            queryParams: {
                connector,
                finance,
                payment_method,
                rewards,
                transactions,
                type
            }
        });
        return createCommonResult(response);
    } catch (e) {
        console.log('Exception getIntegrations: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function getFormAddCard({
    integration_id,
    device_type,
    redirect_url,
    currency_code,
}) {
    try {
        let response = await httpUtil.get({
            resourcePath: '/v2/hosted_pages/payment_methods',
            withAccessToken: true,
            queryParams: {
                integration_id,
                device_type,
                redirect_url,
                currency_code,
            },
            returnText: true
        });
        return createCommonResult(response);
    } catch (e) {
        console.log('Exception getFormAddCard: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function createPayment({
    integration_id,
    client_secret,
    payment_method,
    account_id,
    contact_id,
    external_payable,
    state,
    issued_date,
    posted_date,
    type_id,
    notes,
    code,
    currency_code,
    invoices_paid,
    custom_fields,
    amount,
}) {
    try {
        let response = await httpUtil.post({
            resourcePath: '/v2/payments',
            withAccessToken: true,
            body: {
                integration_id,
                client_secret,
                payment_method,
                account_id,
                contact_id,
                external_payable,
                state,
                issued_date,
                posted_date,
                type_id,
                notes,
                code,
                currency_code,
                invoices_paid,
                custom_fields,
                amount,
            },
            returnText: true
        });
        return createCommonResult(response);
    } catch (e) {
        console.log('Exception createPayment: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function createTopups({
    client_secret,
    payment_method,
    wallet_id,
    amount,
    topup_date,
    code,
    commerce_pool_id,
    custom_fields,
}) {
    try {
        let response = await httpUtil.post({
            resourcePath: '/v2/topups',
            withAccessToken: true,
            body: {
                client_secret,
                payment_method,
                wallet_id,
                amount,
                topup_date,
                code,
                commerce_pool_id,
                custom_fields,
            },
            returnText: true
        });
        return createCommonResult(response);
    } catch (e) {
        console.log('Exception createTopups: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}
